export class CropDetails {
    CropID: string;
    CropGroupName: string;
    CropName: string;
    status: Boolean;
}

export class PackSizeDetails {
    ProductID: string;
    ProductName: string;
    PackSize: string;
    IsActive: Boolean;
}
